import * as yup from 'yup';

type ErrorValues<T> = (T | undefined) & { global?: string[] }

export type ValidationError<Values> = {
  [K in keyof ErrorValues<Values>]?: ErrorValues<Values>[K] extends object ? ValidationError<ErrorValues<Values>[K]> : string[];
} | undefined;

export class IValidator<T> {
  schema: yup.ObjectSchema<yup.Shape<object, any>>;

  constructor(
    schema: yup.ObjectSchema<yup.Shape<object, any>>
  ) {
    this.schema = schema;
  }

  getErrors = (data: T): ValidationError<T> | undefined => {
    try {
      this.schema.validateSync(data, { abortEarly: false });
    } catch (e) {
      if (e instanceof yup.ValidationError) {
        const error = this.mapErrors(data, e.inner);
        return error;
      }
    }
    return undefined;
  }

  private mapErrors = (data: T, errors: yup.ValidationError[]) => {
    return data && Object.keys(data).reduce((result, key) => {
      if (Array.isArray(data[key])) {
        const erroNoArray = errors.find(err => err.path === key); 
        result[key] = erroNoArray ? erroNoArray.message : undefined;

        if(result[key]) return result;
        result[key] = data[key].map((item: any, index: number) =>
          this.mapErrors(
            item, this.filterError(errors, `${key}[${index}]`)
          ));
      } else if (data[key] && typeof data[key] === 'object'  && typeof data[key].type !== 'string') {
        result[key] = this.mapErrors(data[key], this.filterError(errors, key));
      } else {
        const error = errors.find(err => err.path === key);
        result[key] = error ? error.message : undefined;
      }

      return result;

    }, {});
  }

  private filterError = (errors: yup.ValidationError[], key: string) =>
    errors.filter(err => err.path.split('.')[0] === key)
      .map(err => ({ ...err, path: err.path.substr(key.length + 1, err.path.length - key.length) }))
}